/* eslint react/prop-types: 0 */

import * as React from "react";

export interface ImpressProps {
	inline?: boolean;
}

const Impress: React.SFC<ImpressProps> = ({ inline }) => {
	return (
		<div className={inline === true ? "impress about-text" : "impress about-text standalone"}>
			{!inline && <h2>Impressum</h2>}
			<h3>Angaben gemäß § 5 TMG</h3>
			<h4>Verantwortliche Person</h4>
			<p>
				OneDash. <br />
				Christian Bußhoff
				<br />
				Burgstraße 19
				<br />
				54470 Bernkastel - Kues
				<br />
			</p>
			<h4>Kontakt</h4>
			<p>Telefon: +49 160 98739688</p>
			<p>
				E-Mail: <a href="mailto:info@onedash.de">info@onedash.de</a> <br />
				Internet: <a href="www.onedash.de">www.onedash.de</a>
			</p>

			<h3>Angaben zur Berufs&shy;haft&shy;pflicht&shy;versicherung</h3>
			<h4>Name und Sitz des Versicherers:</h4>
			<p>
				Markel Insurance SE
				<br />
				Sophienstr. 26
				<br />
				80333 München
				<br />
				Registergericht: Amtsgericht München Handelsregisternummer: HRB 233618
			</p>
			<h4>Geltungsraum der Versicherung:</h4>
			<p>Deutschland</p>
			<h3>EU-Streitschlichtung</h3>
			<p>
				Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
				<a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a>. Unsere E-Mail-Adresse finden Sie oben
				im Impressum.
			</p>
			<h3>Verbraucher&shy;streitbeilegung / Universal&shy;schlichtungs&shy;stelle</h3>
			<p>
				Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
			</p>

			<h3>Haftungsausschluss</h3>
			<h4>Haftung für Inhalte</h4>
			<p>
				Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
				verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
				fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
				Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon
				unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
				möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
			</p>
			<h4>Haftung für Links</h4>
			<p>
				Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir
				für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
				Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
				Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
				inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
				Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
			</p>
			<h4>Urheberrecht</h4>
			<p>
				Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die
				Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
				schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten,
				nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
				Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
				Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
				Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
			</p>

			<h3>Weiteres</h3>
			<h4>Hyperlinks</h4>
			<p>Hyperlinks auf die Seiten der Webseite sind gestattet.</p>
			<h4>Attribution</h4>
			<p>
				Einige Icons wurden durch Freepik von <a href="www.flaticon.com">www.flaticon.com</a> erstellt.
			</p>
			<h4>Gestaltung</h4>
			<p>
				Diese App wurde von <a href="https://onedash.de">OneDash.</a> erstellt.
			</p>
		</div>
	);
};

export default Impress;
